import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/models/user-model';
import { ChildActivationStart, Router } from '@angular/router';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  
  entity: string = "/auth";
  public currentUserSubject=new BehaviorSubject<User>(JSON.parse(localStorage.getItem('studiomapAdmin')!));
  currentUser = this.currentUserSubject.asObservable();
  // public currentUser: Observable<User>;
  constructor(private http: HttpClient, private router: Router) {
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  callCurrentUserSubject(user: any) {
    this.currentUserSubject.next(user);
  }

  login(identifier: string, password: string): Observable<any> {
    return this.http.post(environment.api + this.entity + "/local/", {
      identifier,
      password
    }, httpOptions);
  }

  logout() {
    localStorage.removeItem('studiomapAdmin');
    this.currentUserSubject.next(null);
    this.router.navigate(['/login']);
    //window.location.reload();
  }

  register(user: User): Observable<any> {
    return this.http.post(environment.api + this.entity + "/local/register", JSON.stringify(user), httpOptions);
  }

  resetPassword(code: string, password: string, passwordConfirmation: string): Observable<any> {
    return this.http.post(environment.api + this.entity + "/reset-password", {
      code,
      password,
      passwordConfirmation
    }, httpOptions);
  }

  forgotPassword(email: string): Observable<any> {
    return this.http.post(environment.api + this.entity + "/forgot-password", {
      email
    }, httpOptions);
  }

  resendConfirmation(email: string): Observable<any> {
    return this.http.post(environment.api + this.entity + "/send-email-confirmation", {
      email
    }, httpOptions);
  }

}
